import type { Decimal } from '#layers/data-model/types/schema/values';
import DecimalNumber from 'decimal.js-light';

/** Validate decimal syntax without rounding or normalizing the original precision and scale. */
export function parseDecimalValue(value: unknown): Decimal | undefined {
	if (typeof value !== 'string') return undefined;
	const text = value.trim();

	try {
		// Validation lives in the constructor; stringifying its result would normalize the text.
		// eslint-disable-next-line no-new
		new DecimalNumber(text);
		return text as Decimal;
	}
	catch {
		return undefined;
	}
}

export function toDecimal(value: string): Decimal {
	const decimal = parseDecimalValue(value);
	if (decimal === undefined) throw new TypeError('Expected a decimal string');
	return decimal;
}
